import { render, staticRenderFns } from "./PainelOportunidadesHeader.vue?vue&type=template&id=02120518"
import script from "./PainelOportunidadesHeader.vue?vue&type=script&lang=js"
export * from "./PainelOportunidadesHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports